const testMessage = {
  heading: "Test Message",
  message: "This is a test message for message container icon",
  positive: true,
};

const accountExists = {
  heading: "Please Login",
  message: "You have an account already please login",
  positive: false
}

const noItemInCart = {
  heading: "No Item In Cart",
  message: "Click add to cart to add item to cart",
  positive: false
}

const noAuthentication = {
  heading : "Not Logged In",
  message:"Please first log in to use services",
  positive: false
}

const invalidCredential = {
  heading : "Invalid Credentials",
  message: "Check email/password and login again",
  positive: false
}

const loginSuccess = {
  heading : "Login Successful",
  message : "You logged in successfully",
  positive: true
}

const logoutSuccess = {
  heading : "Logout Successful",
  message : "You Logged out successfully",
  positive : true
}


export {testMessage,noItemInCart,logoutSuccess,loginSuccess,invalidCredential, accountExists,noAuthentication};